<template>
  <div class="add-company-form">
        <el-dialog title="新增企业" :close-on-click-modal="false" @close="close" :before-close="close" visible>
           <el-form inline ref="formData" :rules="rules" :model="formData" label-width="110px" label-position="right">
             <el-row>
               <el-col :span="24">
                  <el-form-item label="企业名称" class="all-line" prop="username">
                    <el-input v-model="formData.username" placeholder="请填写企业名称"></el-input>
                  </el-form-item>
               </el-col>
             </el-row>
             <el-row>
               <el-col :span="12">
                  <el-form-item label="法人姓名" prop="legalName">
                    <el-input v-model="formData.legalName" placeholder="请填写法人姓名"></el-input>
                  </el-form-item>
               </el-col>
               <el-col :span="12">
                  <el-form-item label="企业手机号" prop="phone">
                    <el-input v-model="formData.phone" placeholder="请填写企业手机号"></el-input>
                  </el-form-item>
               </el-col>
             </el-row>
             <el-row>
               <el-col :span="12">
                  <el-form-item label="证件类型" prop="certType">
                    <el-select v-model="formData.certType" placeholder="请选择证件类型">
                      <el-option label="身份证" value="ID"></el-option>
                      <el-option label="护照" value="P"></el-option>
                      <el-option label="营业执照" value="BL"></el-option>
                      <el-option label="台胞通行证" value="TW"></el-option>
                      <el-option label="港澳通行证" value="HK"></el-option>
                    </el-select>
                  </el-form-item>
               </el-col>
               <el-col :span="12">
                  <el-form-item label="证件号码" prop="certNumber">
                    <el-input v-model="formData.certNumber" placeholder="请填写证件号码"></el-input>
                  </el-form-item>
               </el-col>
             </el-row>
             <el-row>
               <el-col :span="24">
                  <el-form-item label="企业地区" class="all-line" prop="originAddress">
                    <el-cascader
                      v-model="formData.originAddress"
                      :change-on-select="false"
                      :options="options"
                      @change="getChildrenArea"
                      @active-item-change="handleItemChange"
                    ></el-cascader>
                  </el-form-item>
               </el-col>
             </el-row>
             <el-row>
               <el-col :span="24">
                  <el-form-item label="企业地址" class="all-line" prop="address">
                    <el-input v-model="formData.address" placeholder="请填写企业地址"></el-input>
                  </el-form-item>
               </el-col>
             </el-row>
             <el-row>
                <el-form-item label="证件照片" prop="companyFileList">
                  <!-- 饿了么上传图片控件 -->
                  <el-upload
                    :action="ossBaseUrl"
                    accept="image/*"
                    list-type="picture-card"
                    :auto-upload="false"
                    :on-remove="handleRemove"
                    :on-change="changeFileList" :fileList="formData.companyFileList">
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </el-form-item>
             </el-row>
             <el-row class="separate-line"></el-row>
             <el-row>
               <el-col :span="12">
                  <el-form-item label="联系人姓名" prop="dutyUsername">
                    <el-input v-model="formData.dutyUsername" placeholder="请填写联系人姓名"></el-input>
                  </el-form-item>
               </el-col>
               <el-col :span="12">
                  <el-form-item label="联系人手机号" prop="dutyPhone">
                    <el-input v-model="formData.dutyPhone" placeholder="请填写联系人手机号"></el-input>
                  </el-form-item>
               </el-col>
             </el-row>
             <el-row>
               <el-col :span="12">
                  <el-form-item label="证件类型" prop="dutyCertType">
                    <el-select v-model="formData.dutyCertType" placeholder="请选择证件类型">
                      <el-option label="身份证" value="ID"></el-option>
                      <el-option label="护照" value="P"></el-option>
                      <el-option label="台胞通行证" value="TW"></el-option>
                      <el-option label="港澳通行证" value="HK"></el-option>
                    </el-select>
                  </el-form-item>
               </el-col>
               <el-col :span="12">
                  <el-form-item label="证件号码" prop="dutyCertNumber">
                    <el-input v-model="formData.dutyCertNumber" placeholder="请填写证件号码"></el-input>
                  </el-form-item>
               </el-col>
             </el-row>
             <el-row>
                <el-form-item label="证件照片" prop="dutyFileList">
                  <!-- 饿了么上传图片控件 -->
                  <el-upload
                    :action="ossBaseUrl"
                    accept="image/*"
                    list-type="picture-card"
                    :auto-upload="false"
                    :on-remove="handleDutyRemove"
                    :on-change="changeDutyFileList" :fileList="formData.dutyFileList">
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </el-form-item>
             </el-row>
           </el-form>
           <div slot="footer" class="dialog-footer">
              <el-button type="primary" :loading="isLoading" @click="submit('formData')">提 交</el-button>
		       </div>
        </el-dialog>
  </div>

</template>
<script>
import co from 'co'
import OSS from 'ali-oss'
import accountApi from '@/xhr/services/account'
import { dealWithBlank } from './enum.js'
import { k1 } from '@/xhr/services/osssp'
export default {
  data() {
    // 身份证和护照验证
    var checkIdcard = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('证件号码不能为空'))
      }
      setTimeout(() => {
        if (this.formData.certType === 'ID' && value.length !== 9 && value.length !== 18 && value.length !== 10 && value.length !== 15) {
          callback(new Error('请输入正确的证件号码'))
        } else {
          callback()
        }
      }, 100)
    }
    var checkDutyIdcard = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('证件号码不能为空'))
      }
      setTimeout(() => {
        if (this.formData.dutyCertType === 'ID' && value.length !== 9 && value.length !== 18 && value.length !== 10 && value.length !== 15) {
          callback(new Error('请输入正确的证件号码'))
        } else {
          callback()
        }
      }, 100)
    }
    var checkCompanyPhone = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('手机号不能为空'))
        } else {
          let val = value.replace(/^\s*|\s*$/g, '')
          if (!val || val.length !== 11 || isNaN(val)) {
            return callback(new Error('手机号格式不正确'))
          } else if (this.formData.dutyPhone && val === this.formData.dutyPhone) {
            return callback(new Error('企业电话不能与负责人电话相同'))
          } else {
            callback()
          }
        }
    }
    var checkDutyPhone = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('手机号不能为空'))
        } else {
          let val = value.replace(/^\s*|\s*$/g, '')
          if (!val || val.length !== 11 || isNaN(val)) {
            return callback(new Error('手机号格式不正确'))
          } else if (this.formData.phone && val === this.formData.phone) {
            console.log(val, this.formData.phone)
            return callback(new Error('负责人电话不能与企业电话相同'))
          } else {
            callback()
          }
        }
    }
    var checkOriginAddress = (rule, value, callback) => {
      if (!value.length) {
        return callback(new Error('请选择企业地址'))
      } else {
        callback()
      }
    }
    var checkCompanyFileList = (rule, value, callback) => {
      if (!value.length) {
        return callback(new Error('请上传证件照片'))
      } else {
        callback()
      }
    }
    return {
      originAddress: '',
      ossBaseUrl: 'http://' + k1.a_7 + '-' + k1.a_5 + k1.a_9 + '-' + k1.a_6 + '.' + k1.a_4 + '-' + k1.a_3 + '-' + k1.a_0 + '.' + k1.a_2 + k1.a_8 + k1.a_1 + '.com/',
      fileList: [],
      formData: {
        address: '',  // 企业地址
        certNumber: '',  // 证件号码
        certType: '',  // 证件类型
        legalName: '',  // 法人姓名
        city: '',
        province: '',
        phone: '',
        region: '',  // 行政区
        tenantType: 'ENTERPRISE',  // 租客类型
        username: '',
        originAddress: [],  // 企业地址数组
        companyFileList: [],

        dutyUsername: '',  // 负责人姓名
        dutyPhone: '',
        dutyCertType: '',  // 证件类型
        dutyCertNumber: '',  // 证件号码
        dutyTenantType: 'HEADOFENTERPRISE',  // 租客类型
        dutyFileList: [],
      },
      options: [],    // 省市区枚举
      areaMessage: [],  // 接口获取的原始 地区数据
      isLoading: false,
      rules: {
        username: [{required: true, message: '请填写企业名称', trigger: 'blur'}],
        legalName: [{required: true, message: '请填写法人姓名', trigger: 'blur'}],
        phone: [{required: true, trigger: 'blur', validator: checkCompanyPhone}],
        certType: [{required: true, message: '请选择证件类型', trigger: 'change'}],
        certNumber: [{ required: true, validator: checkIdcard, trigger: 'blur' }],
        originAddress: [{required: true, validator: checkOriginAddress, trigger: 'change'}],
        address: [{required: true, message: '请填写企业地址', trigger: 'blur'}],
        dutyUsername: [{required: true, message: '请填写负责人姓名', trigger: 'blur'}],
        dutyPhone: [{required: true, trigger: 'blur', validator: checkDutyPhone}],
        dutyCertType: [{required: true, message: '请选择证件类型', trigger: 'change'}],
        dutyCertNumber: [{ required: true, validator: checkDutyIdcard, trigger: 'blur' }],
        companyFileList: [{required: true, validator: checkCompanyFileList, trigger: 'change'}],
        dutyFileList: [{required: true, validator: checkCompanyFileList, trigger: 'change'}],
      }
    }
  },
  props: {
    addCompanyShow: {
      type: Boolean,
      default: false
    },
    addCompanyData: {
      type: Object,
      required: true
    }
  },
  watch: {
    addCompanyShow(val) {

    }
  },
  created() {
    // 获取省份信息
    let params = {'baseDataType': 'PROVINCE__INFO'}
    this.getProvinceInfo(params, 'province')  // 获取省份信息
  },
  computed: {
  },
  methods: {
    close() {
      let val = 'addCompany'
      this.$emit('closeAddCompany', val)
    },
    // 改变文件列表
    changeFileList(file, fileList) {
      // (raw, name, size, uid, url)
      this.formData.companyFileList = fileList
      this.$refs.formData.validateField('companyFileList')
    },
    changeDutyFileList(file, fileList) {
       this.formData.dutyFileList = fileList
       this.$refs.formData.validateField('dutyCertNumber')
    },
    // 删除图片文件
    handleRemove(file, fileList) {
      this.formData.companyFileList = fileList
    },
    handleDutyRemove(file, fileList) {
      this.formData.dutyFileList = fileList
    },
    // 根据本地图片列表上传
    uploadFileList(fileList) {
      const registerToken = (fileCount) => {
        return new Promise((resolve, reject) => {
          this.$http.post(this.urljoin(this.urlList.pdf, 'token'), {
            fileCount,
            ossType: 'image'
          }).then(res => {
            if (res.data.code !== 200) {
              this.$message.error(`上传失败。原因：${res.data.message}`)
              reject()
            } else {
              resolve(res.data.data)
            }
          })
        })
      }

      return new Promise((resolve, reject) => {
        registerToken(fileList.length).then(({key, secret, fileNames}) => {
          const client = new OSS({
            region: k1.a_4 + '-cn-' + k1.a_0,
            accessKeyId: key,
            accessKeySecret: secret,
            bucket: k1.a_7 + '-' + k1.a_5 + k1.a_9 + '-' + k1.a_6
          })

          co(function* () {
            let ret = []
            for (let i = 0; i < fileNames.length; i++) {
              const o = yield client.put(fileNames[i], fileList[i].raw)
              ret.push(o)
            }
            resolve(ret)
          }).catch(err => {
            this.$message.error(`OSS上传失败。原因：${err.code}`)
            reject()
          })
        })
      })
    },
    // 获取省份信息
    getProvinceInfo(params, type) {
          // 加载第一级的省
      this.$http.post(this.$store.state.searchUrl + 'baseDataInfo', params).then(function(response) {
        // 响应成功回调
        let data = response.data
        if (data.code === 200 && data.data && data.data.length) {
          let options = []
          this.areaMessage = data.data
          data.data.forEach((item, index) => {
              let obj = {}
              obj.label = item[type]
              obj.value = item[`${type}Id`]
              obj.children = []
              options.push(obj)
            if (type === 'province') {
              this.options = options
            } else if (type === 'city') {
              this.options.forEach(tip => {
                if (tip.value === params.provinceId) {
                  tip.children = options
                }
              })
            } else if (type === 'area') {
              this.options.forEach(tip => {
                if (tip.children && tip.children.length) {
                  tip.children.forEach(item => {
                    options.forEach(tip => { delete tip['children'] })
                    item.children = options
                  })
                }
              })
            }
          })
        }
      }, function(response) {
        // 响应错误回调
      })
    },
    // 提交
    submit(val) {
      this.$refs[val].validate((valid) => {
        if (valid) {
          this.isLoading = true
          let { address, certNumber, certType, legalName, city, province, phone, region, tenantType, username, companyFileList, dutyUsername, dutyPhone, dutyCertType, dutyCertNumber, dutyTenantType, dutyFileList } = this.formData

          let companyObj = { address, certNumber, certType, legalName, city, province, phone, region, tenantType, username, userEnckosureBeans: [] }
          let dutyObj = {
            username: dutyUsername,
            phone: dutyPhone,
            certType: dutyCertType,
            certNumber: dutyCertNumber,
            tenantType: dutyTenantType,
            userEnckosureBeans: []
          }
          dealWithBlank(companyObj)  // 处理 companyObj 对象中的字符串两端空格
          dealWithBlank(dutyObj)  // 处理 dutyObj 对象中的字符串两端空格
          // 上传 图片，获取链接
          Promise.all([this.uploadFileList(companyFileList), this.uploadFileList(dutyFileList)]).then(val => {
            if (val.length === 2) {
              val[0].forEach(item => {
                  let obj = {}
                  obj.addr = item.url
                  obj.attachmentType = 'CERTIFICATES'
                  companyObj.userEnckosureBeans.push(obj)
              })
              val[1].forEach(item => {
                  let obj = {}
                  obj.addr = item.url
                  obj.attachmentType = 'CERTIFICATES'
                  dutyObj.userEnckosureBeans.push(obj)
              })

              this.addCompanyData.userBeanList[0] = companyObj
              this.addCompanyData.userBeanList[1] = dutyObj
              this.addCompanyMessage(this.addCompanyData)
            }
          })
        }
      })
    },
    // 新增企业函数
    addCompanyMessage(val) {
      accountApi.businessInfo(val).then(res => {
        if (res.data.code === 200 && res.data.message === 'success') {
          this.$message.success('企业新增成功')
          this.close()  // 关闭弹窗
        } else {
          this.isLoading = false
          this.$message.error(res.data.message)
        }
      })
    },
    // 点击选取 省份
    getChildrenArea (val) {
      this.getAddressOfWord(val)
    },
    // 获取
    handleItemChange(val) {
        if (val && val.length) {
          // 获取市级列表
          if (val.length === 1) {
            let params = {
              baseDataType: 'CITY_INFO',
              provinceId: val[0]
            }
            this.getProvinceInfo(params, 'city')
          } else if (val.length === 2) {
            let params = {
              baseDataType: 'AREA_INFO',
              cityId: val[1]
            }
            this.getProvinceInfo(params, 'area')
          }
        }
    },
    // 地区选择之后，获取对应的汉字字段
    getAddressOfWord(val) {
      if (val && val.length === 3) {
        let provinceId = val[0]
        let cityId = val[1]
        let areaId = val[2]
        let province, city, area
        this.options.forEach(item => {
          if (item.value === provinceId) {
            province = item.label
            let cityInfo = item.children
            cityInfo.forEach(item => {
              if (item.value === cityId) {
                city = item.label
                let areaInfo = item.children
                areaInfo.forEach(item => {
                  if (item.value === areaId) {
                    area = item.label
                  }
                })
              }
            })
          }
        })
        this.formData.province = province
        this.formData.city = city
        this.formData.region = area
      }
    },
  },
  filters: {
    dealWithBlank,  // 去除字符串两端空格
  }
}
</script>
<style lang="scss" scoped>
  .add-company-form {
    font-family:MicrosoftYaHei;
    font-size: 14px;
    color: #333333;
    .all-line {
      width: 100%;
    }
    .separate-line {
      height: 0;
      border-bottom: 1px solid #E0E0E0;
      margin-bottom: 20px;
    }
  }
</style>
<style>
/* 修改 element-ui 样式 */
  .add-company-form .all-line .el-form-item__content{
    width: 77.5%;
  }
  .add-company-form .all-line .el-form-item__content .el-cascader{
    width: 100%;
  }
  .add-company-form .el-input__icon+.el-input__inner {
    padding-right: 10px;
  }
  .add-company-form .el-dialog{
    width: 665px !important;
  }
</style>




// WEBPACK FOOTER //
// src/components/forms/AddBusinessForm/index.vue